import React from 'react';
import SalesLetterWrapper from './SalesLetterWrapper';
import SafeIcon from '../common/SafeIcon';
import { FiPlus } from 'react-icons/fi';

const StackLine = ({ title, content, value, isBonus = false }) => (
  <div className={`p-6 md:p-8 rounded-3xl border-2 flex flex-col md:flex-row items-center gap-6 ${isBonus ? 'bg-brand-gold/5 border-dashed border-brand-gold/20' : 'bg-white border-slate-100 shadow-sm'}`}>
    <div className="flex-grow">
      <div className="flex items-center gap-3 mb-2">
        {isBonus && <span className="px-2 py-0.5 bg-brand-gold text-white text-[10px] font-black uppercase rounded">Bonus</span>}
        <h4 className="text-xl font-bold text-brand-dark">{title}</h4>
      </div>
      <p className="text-text-secondary text-base leading-relaxed">{content}</p>
    </div>
    <div className="text-right min-w-[100px] border-t md:border-t-0 md:border-l border-slate-200 pt-4 md:pt-0 md:pl-8">
      <p className="text-[10px] font-black text-slate-400 uppercase tracking-widest">Value</p>
      <p className="text-2xl font-black text-brand-dark">${value}</p>
    </div>
  </div>
);

const ValueStackLetter = () => {
  return (
    <SalesLetterWrapper>
      <div className="text-center mb-16">
        <h2 className="text-3xl md:text-5xl font-display font-black text-brand-dark mb-6">
          Here’s Everything You’ll Get Today
        </h2>
      </div>

      <div className="space-y-4">
        <StackLine 
          title="The Complete “Simple Online Income For Retirees” eBook" 
          content="A step-by-step guide covering methods, scams, AI, and portable strategies." 
          value="97" 
        />
        <StackLine 
          title="The Mini Video Course" 
          content="Simple walkthrough videos explaining basics, tools, and practical first steps." 
          value="147" 
        />
        <StackLine 
          title="The SAFE Framework™ Training" 
          content="Learn how to quickly evaluate ANY online opportunity." 
          value="47" 
        />
        
        <div className="py-8 text-center flex items-center gap-4">
          <div className="h-px flex-grow bg-slate-200"></div>
          <SafeIcon icon={FiPlus} className="text-brand-gold text-2xl" />
          <div className="h-px flex-grow bg-slate-200"></div>
        </div>

        <StackLine isBonus title="BONUS #1 — The Scam Detection Checklist" content="Protect yourself from fake gurus and risky schemes." value="27" />
        <StackLine isBonus title="BONUS #2 — 50 Remote Work Websites" content="A curated list of retiree-friendly platforms." value="47" />
        <StackLine isBonus title="BONUS #3 — Simple AI Tools For Retirees" content="Learn tools that simplify writing and organization." value="37" />
        <StackLine isBonus title="BONUS #4 — Portable Retirement Tech Guide" content="Work from home, caravans, or while travelling." value="27" />
        <StackLine isBonus title="BONUS #5 — Freedom Planning Worksheet" content="Clarify your goals and income targets." value="17" />
      </div>

      <div className="mt-16 bg-brand-dark text-white p-12 rounded-[3rem] text-center shadow-2xl">
        <p className="text-xl font-bold uppercase tracking-[0.2em] text-brand-gold mb-4">Total Value:</p>
        <p className="text-6xl font-display font-black mb-12">$399+</p>
        
        <div className="h-px w-full bg-white/10 mb-12"></div>
        
        <p className="text-2xl font-light italic mb-8">But today… You won’t pay hundreds of dollars. You can get instant access today for just:</p>
        <p className="text-[10rem] font-display font-black leading-none mb-12 text-white">$27</p>
        
        <div className="space-y-8">
          <h3 className="text-2xl font-bold text-brand-gold">Why The Price Is So Low</h3>
          <p className="text-xl text-blue-100 font-light max-w-xl mx-auto">
            Because the goal is simple: To help more retirees reduce overwhelm, avoid scams, build confidence online, and discover practical opportunities.
          </p>
        </div>
      </div>
    </SalesLetterWrapper>
  );
};

export default ValueStackLetter;